export default {
  'auth.welcome': 'Bienvenido de nuevo',
  'auth.subtitle': 'Inicia sesión con tu cuenta NexChat. Tus mensajes son privados y seguros.',
  'auth.continue': 'Continuar con NexChat',
  'app.name': 'NexChat',
  'app.loading': 'Cargando…',
  'app.online': 'En línea',
  'app.away': 'Ausente',
  'app.busy': 'Ocupado',
  'app.appear_offline': 'Aparecer desconectado',
  'sidebar.conversations': 'Tus conversaciones',
  'sidebar.new_conversation': 'Nueva conversación',
  'sidebar.search': 'Buscar conversaciones…',
  'sidebar.loading': 'Cargando salas…',
  'sidebar.empty': 'Sin conversaciones aún.\nCrea una para comenzar.',
  'sidebar.select': 'Selecciona una conversación o inicia una nueva.',
  'chat.encrypted': 'Esta conversación está cifrada de extremo a extremo',
  'chat.loading': 'Cargando mensajes…',
  'chat.no_messages': 'Sin mensajes aún',
  'chat.be_first': '¡Sé el primero en decir algo!',
  'chat.voice_call': 'Llamada de voz',
  'chat.video_call': 'Videollamada',
  'chat.pins': 'Mensajes fijados',
  'chat.starred': 'Mensajes destacados',
  'chat.search': 'Buscar mensajes',
  'input.placeholder': 'Mensaje {room}…',
  'input.hint_send': 'Presiona {enter} para enviar · {shift_enter} para nueva línea',
  'input.poll': 'Crear encuesta',
  'input.gif': 'GIF y Stickers',
  'input.attach': 'Adjuntar archivo',
  'input.schedule': 'Programar mensaje',
  'input.record': 'Mantén o haz clic para grabar',
  'input.nexai': 'Preguntar a NexAI',
  'msg.reply': 'Responder',
  'msg.edit': 'Editar',
  'msg.delete': 'Eliminar',
  'msg.copy': 'Copiar',
  'msg.forward': 'Reenviar',
  'msg.pin': 'Fijar',
  'msg.unpin': 'Desfijar',
  'msg.star': 'Destacar',
  'msg.unstar': 'Quitar destacado',
  'msg.thread': 'Hilo',
  'msg.translate': 'Traducir',
  'msg.react': 'Reaccionar',
  'msg.edited': 'editado',
  'msg.deleted': 'Este mensaje fue eliminado',
  'thread.title': 'Hilo',
  'thread.replies': 'Respuestas',
  'thread.reply_placeholder': 'Responder en el hilo…',
  'thread.hint': 'Enter para responder · Shift+Enter para nueva línea',
  'thread.summarise': '✨ Resumen',
  'thread.summarising': '⏳ Resumiendo…',
  'thread.summary_title': '✨ Resumen IA',
  'thread.not_enough': 'No hay suficientes mensajes para resumir',
  'nexai.placeholder': 'Preguntar a NexAI…',
  'nexai.title': 'NexAI',
  'nexai.thinking': 'Pensando…',
  'nexai.clear': 'Limpiar',
  'search.title': 'Buscar mensajes',
  'search.placeholder': 'Buscar mensajes, personas, palabras clave…',
  'search.empty': 'Escribe para buscar',
  'search.no_results': 'Sin resultados',
  'search.searching': 'Buscando…',
  'search.results': '{count} resultado{plural}',
  'profile.edit': 'Editar perfil',
  'profile.theme': 'Tema',
  'profile.scheduled': 'Mensajes programados',
  'profile.notifications': 'Notificaciones',
  'profile.logout': 'Cerrar sesión',
  'theme.title': '🎨 Elegir tema',
  'theme.subtitle': '12 temas — variantes claras y oscuras.',
  'theme.close': 'Cerrar',
  'notif.title': 'Configuración de notificaciones',
  'notif.browser': 'Notificaciones del navegador',
  'notif.browser_sub': 'Mostrar alertas de escritorio para nuevos mensajes',
  'notif.sound': 'Notificaciones de sonido',
  'notif.sound_sub': 'Reproducir un sonido para nuevos mensajes',
  'notif.volume': 'Volumen',
  'notif.push': 'Notificaciones push',
  'notif.push_sub': 'Recibir alertas incluso cuando NexChat está cerrado',
  'notif.push_enabled': '✓ Activado',
  'notif.push_enable': 'Activar push',
  'notif.push_enabling': 'Activando…',
  'notif.sounds_title': 'Sonidos personalizados',
  'notif.preview': '▶ Vista previa',
  'notif.upload': '📎 Subir',
  'notif.clear': '✕ Limpiar',
  'notif.new_message': 'Nuevo mensaje',
  'notif.mention': '@ Mención',
  'notif.dm': 'Mensaje directo',
  'notif.ringtone': 'Tono de llamada',
  'notif.save': 'Guardar',
  'notif.close': 'Cerrar',
  'room.new_title': 'Nueva conversación',
  'room.dm_tab': '💬 Mensaje directo',
  'room.channel_tab': '# Canal',
  'room.dm_placeholder': '@usuario:nexchat.ethosserver.com',
  'room.channel_placeholder': 'ej. general',
  'room.channel_label': 'Nombre del canal',
  'room.dm_label': 'Usuario',
  'room.start_dm': 'Iniciar conversación',
  'room.create_channel': 'Crear canal',
  'room.cancel': 'Cancelar',
  'poll.create': 'Crear encuesta',
  'poll.question': 'Pregunta',
  'poll.question_placeholder': 'Haz una pregunta…',
  'poll.option': 'Opción {n}',
  'poll.add_option': '+ Agregar opción',
  'poll.single': 'Opción única',
  'poll.multi': 'Opción múltiple',
  'poll.anonymous': 'Anónimo',
  'poll.submit': 'Crear encuesta',
  'poll.cancel': 'Cancelar',
  'poll.end': 'Finalizar encuesta',
  'poll.ended': 'Encuesta finalizada',
  'poll.votes': '{n} voto{plural}',
  'schedule.title': '⏰ Programar mensaje',
  'schedule.send_at': 'Enviar a las',
  'schedule.quick': 'Selección rápida',
  'schedule.30min': '⚡ 30 min',
  'schedule.1h': '☕ 1 hora',
  'schedule.3h': '🕒 3 horas',
  'schedule.tomorrow': '📅 Mañana',
  'schedule.next_week': '📆 Próxima semana',
  'schedule.confirm': 'Programar envío',
  'schedule.cancel': 'Cancelar',
  'schedule.list_title': '⏰ Mensajes programados',
  'schedule.list_empty': 'Sin mensajes programados',
  'schedule.list_desc': 'Mensajes en cola. Entregados en 30 segundos del tiempo programado.',
  'schedule.close': 'Cerrar',
  'btn.save': 'Guardar',
  'btn.cancel': 'Cancelar',
  'btn.close': 'Cerrar',
  'btn.send': 'Enviar',
  'btn.delete': 'Eliminar',
  'btn.edit': 'Editar',
  'btn.confirm': 'Confirmar',
  'toast.copied': 'Copiado al portapapeles',
  'toast.message_deleted': 'Mensaje eliminado',
  'toast.profile_updated': 'Perfil actualizado',
  'toast.offline_queued': 'Sin conexión — mensaje en cola',
  'toast.back_online': 'De vuelta en línea — enviado {count} mensaje{plural}',
  'toast.scheduled': 'Programado para {time}',
  'toast.poll_created': '¡Encuesta creada!',
};
